export const MobileHomeInformationFieldNames = {
  LoadIsMobileHome: 'loadIsMobileHome',
  IsUsedMobileHome: 'isUsedMobileHome',
  MobileHomeYear: 'mobileHomeYear',
  MobileHomeMake: 'mobileHomeMake',
  MobileHomeSerialNumber: 'mobileHomeSerialNumber',
  MobileHomeHitchLength: 'mobileHomeHitchLength',
  MobileHomeEaveWidth: 'mobileHomeEaveWidth',
  MobileHomeBoxWidth: 'mobileHomeBoxWidth',
  MobileHomeBoxLength: 'mobileHomeBoxLength',
  MobileHomeRoadsideEavesLength: 'mobileHomeRoadsideEavesLength',
  MobileHomeCurbsideEavesLength: 'mobileHomeCurbsideEavesLength',
  MobileHomeHudNumber: 'mobileHomeHudNumber',
} as const;

export type MobileHomeInformationFields = {
  [MobileHomeInformationFieldNames.LoadIsMobileHome]?: boolean;
  [MobileHomeInformationFieldNames.IsUsedMobileHome]?: boolean;
  [MobileHomeInformationFieldNames.MobileHomeYear]?: number;
  [MobileHomeInformationFieldNames.MobileHomeMake]?: string;
  [MobileHomeInformationFieldNames.MobileHomeSerialNumber]?: string;
  [MobileHomeInformationFieldNames.MobileHomeHitchLength]?: number | string;
  [MobileHomeInformationFieldNames.MobileHomeEaveWidth]?: number | string;
  [MobileHomeInformationFieldNames.MobileHomeBoxWidth]?: number | string;
  [MobileHomeInformationFieldNames.MobileHomeBoxLength]?: number | string;
  [MobileHomeInformationFieldNames.MobileHomeRoadsideEavesLength]?:
    | number
    | string;
  [MobileHomeInformationFieldNames.MobileHomeCurbsideEavesLength]?:
    | number
    | string;
  [MobileHomeInformationFieldNames.MobileHomeHudNumber]?: string;
};

export const MobileHomeFields: string[] = Object.values(
  MobileHomeInformationFieldNames,
);
